import { render } from "./BookingOnBehalfOf.vue?vue&type=template&id=4f02f597"
import script from "./BookingOnBehalfOf.vue?vue&type=script&lang=js"
export * from "./BookingOnBehalfOf.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/abdom-booking/abdom-booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__